import styled from '@emotion/styled';

export const ContentWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
`;